import { Link } from 'react-router-dom';
import { ListingItemStyle } from '../ScreenArtists';
import { routes } from 'routes';
import { css } from '@emotion/react';
import { LinkExternal } from 'components/LinkExternal';
import { theme } from 'styles/theme';
import { Badge } from 'components/Badge';
import slugify from '@sindresorhus/slugify';
import { Artist } from 'generated/graphql';

export const ArtistItem = ({ item }: { item: Artist }) => {
	const { id, name, url, rider_link, vat_invoicing } = item;

	const thumbSize = 40;

	return (
		<Link
			key={id}
			to={routes.booker.artist + id}
			css={[
				ListingItemStyle(),
				css`
					align-items: center;
					padding: 8px 24px 8px 8px;
					border: 0;
				`,
			]}
		>
			<div
				css={css`
					display: flex;
					align-items: center;
					gap: 16px;
				`}
			>
				<div
					css={css`
						width: ${thumbSize}px;
						height: ${thumbSize}px;
						border-radius: 16px;
						overflow: hidden;
					`}
				>
					<img
						css={css`
							width: 100%;
						`}
						src={process.env.ASSETS_URL + 'artists/' + url + '.png'}
					/>
				</div>

				<strong>{name}</strong>
			</div>

			<div
				css={css`
					width: 280px;
					display: flex;
					justify-content: space-between;
					gap: 20px;
				`}
			>
				<Badge success={!!vat_invoicing}>{vat_invoicing ? 'Plátce DPH' : 'Neplátce DPH'}</Badge>

				{rider_link ? (
					<LinkExternal href={rider_link}>Otevrit rider</LinkExternal>
				) : (
					<small
						css={css`
							color: ${theme.color.danger[400]};
							font-weight: 600;
						`}
					>
						Rider nevyplnen
					</small>
				)}
			</div>
		</Link>
	);
};
